<script setup lang="ts">
import { onBeforeUnmount, useAttrs, watchEffect } from 'vue';

import { injectMenuContext } from './context';
import KaMenuItem from './KaMenuItem.vue';
import type { KaMenuGroupProps } from './types';

export type { KaMenuGroupProps } from './types';

const props = defineProps<KaMenuGroupProps>();

const menuGroupId = Symbol('menuGroupId');
const menu = injectMenuContext();
const attrs = useAttrs();

const menuDataTestid = menu?.dataTestid || undefined;
const dataTestid = (attrs['data-testid'] as string) || menuDataTestid?.value || undefined;

watchEffect(() => {
  if (menu) {
    menu.registerMenuGroup(menuGroupId);
  }
});

onBeforeUnmount(() => {
  if (menu) {
    menu.deregisterMenuGroup(menuGroupId);
  }
});
</script>

<template>
  <ul
    class="m-0 w-full list-none px-0 py-0.5"
    :data-testid="(attrs['data-testid'] as string) || `${menuDataTestid}-menu-group`"
    role="group"
  >
    <slot v-if="!props.items" />

    <KaMenuItem
      v-for="item in props.items"
      v-else
      :key="item.label"
      :data-testid="`${dataTestid}-menu-item-${item.label}`"
      :label="item.label"
      :left="item.left"
      :right="item.right"
      :danger="item.danger"
      :disabled="item.disabled"
      :on-click="item.onClick"
      :as="item.as"
      :link-props="item.as === 'link' ? item.linkProps : undefined"
      :button-classes="item.as === 'button' ? item.buttonClasses : undefined"
      :container-classes="item.containerClasses"
      :sr-only-label="item.srOnlyLabel"
    />
  </ul>
</template>
